import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { cacheTestResult } from '../helpers/cache-test-result';
import { testAudioBufferCopyChannelMethodsSubarraySupport } from '../support-testers/audio-buffer-copy-channel-methods-subarray';
import { wrapAudioBufferCopyChannelMethods } from '../wrappers/audio-buffer-copy-channel-methods';
import { wrapAudioBufferCopyChannelMethodsSubarray } from '../wrappers/audio-buffer-copy-channel-methods-subarray';
import { wrapAudioBufferGetChannelDataMethod } from '../wrappers/audio-buffer-get-channel-data-method';
var DEFAULT_OPTIONS = {
  numberOfChannels: 1
};
export var createAudioBufferConstructor = function createAudioBufferConstructor(createNotSupportedError, nativeAudioBufferConstructor, nativeOfflineAudioContextConstructor, testNativeAudioBufferConstructorSupport) {
  var nativeOfflineAudioContext = null;
  return (
    /*#__PURE__*/
    function () {
      function AudioBuffer(options) {
        _classCallCheck(this, AudioBuffer);

        if (nativeOfflineAudioContextConstructor === null) {
          throw new Error(); // @todo
        }

        var _DEFAULT_OPTIONS$opti = _objectSpread({}, DEFAULT_OPTIONS, options),
            length = _DEFAULT_OPTIONS$opti.length,
            numberOfChannels = _DEFAULT_OPTIONS$opti.numberOfChannels,
            sampleRate = _DEFAULT_OPTIONS$opti.sampleRate;

        if (nativeOfflineAudioContext === null) {
          nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        }
        /*
         * Bug #99: Firefox does not throw a NotSupportedError when the numberOfChannels is zero. But it only does it when using the
         * factory function. But since Firefox also supports the constructor everything should be fine.
         */


        var audioBuffer = nativeAudioBufferConstructor !== null && cacheTestResult(testNativeAudioBufferConstructorSupport, testNativeAudioBufferConstructorSupport) ? new nativeAudioBufferConstructor({
          length: length,
          numberOfChannels: numberOfChannels,
          sampleRate: sampleRate
        }) : nativeOfflineAudioContext.createBuffer(numberOfChannels, length, sampleRate); // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
        // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.

        if (typeof audioBuffer.copyFromChannel !== 'function') {
          wrapAudioBufferCopyChannelMethods(audioBuffer);
          wrapAudioBufferGetChannelDataMethod(audioBuffer); // Bug #42: Firefox does not yet fully support copyFromChannel() and copyToChannel().
        } else if (!cacheTestResult(testAudioBufferCopyChannelMethodsSubarraySupport, function () {
          return testAudioBufferCopyChannelMethodsSubarraySupport(audioBuffer);
        })) {
          wrapAudioBufferCopyChannelMethodsSubarray(audioBuffer);
        } // Bug #99: Safari does not throw an error when the numberOfChannels is zero.


        if (audioBuffer.numberOfChannels === 0) {
          throw createNotSupportedError();
        }
        /*
         * This does violate all good pratices but it is necessary to allow this AudioBuffer to be used with native
         * (Offline)AudioContexts.
         */


        return audioBuffer;
      } // This method needs to be defined to convince TypeScript that the IAudioBuffer will be implemented.


      _createClass(AudioBuffer, [{
        key: "copyFromChannel",
        value: function copyFromChannel(_1, _2) {
          var _3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        } // tslint:disable-line:no-empty
        // This method needs to be defined to convince TypeScript that the IAudioBuffer will be implemented.

      }, {
        key: "copyToChannel",
        value: function copyToChannel(_1, _2) {
          var _3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        } // tslint:disable-line:no-empty
        // This method needs to be defined to convince TypeScript that the IAudioBuffer will be implemented.

      }, {
        key: "getChannelData",
        value: function getChannelData(_) {
          return new Float32Array(0);
        }
      }]);

      return AudioBuffer;
    }()
  );
};